export default __webpack_public_path__ + "static/media/amazon.680cfc62.png";